module.exports = __webpack_public_path__ + "img/antes_despues_05.5f9528ce.png";